export default __webpack_public_path__ + "static/media/Logo_round-small.50c2c4ee.png";